import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { JsonResponse } from '../api/backend-config';
import { getKeyByValue } from '../util/getKeyByValue';
import { NaturalId } from '../../map/menu/right-menu/layers-menu/population-menu/population.service';

export enum AiDescriptionSections {
  GENERAL_OVERVIEW = 'General overview',
  HOUSING = 'Housing',
  HEALTH = 'Health',
  WEALTH = 'Wealth',
  WISDOM = 'Wisdom',
  NEIGHBORS = 'Neighbors',
  EDUCATION = 'Education',
  ENVIRONMENT = 'Environment',
  CRIME = 'Crime',
}

export type AiDescriptionResponse = {
  systemPrompt: string; // for debug
  prompt: string; // for debug
  text: string;
};

export type CategoryScore = {
  category: AiDescriptionSections;
  summary: string;
  score: number;
};

export type AiSummaryWithScore = {
  locationName: string;
  naturalCellId: string;
  cellType: string;
  categoryScores: CategoryScore[];
};

export type CellAiSummaryRequestData = {
  locationName: string;
  naturalCellId: NaturalId;
  cellType: string;
};

@Injectable({
  providedIn: 'root',
})
export class AiService {
  public featureToAiResponseMap: Map<
    string,
    Partial<Record<AiDescriptionSections, string>>
  > = new Map();

  constructor(private http: HttpClient) {}

  public getCellDescription(
    geoId: string,
    cellType: string,
    section: string
  ): Observable<JsonResponse<AiDescriptionResponse>> {
    const sectionKey = getKeyByValue(AiDescriptionSections, section);

    return this.http.get<JsonResponse<AiDescriptionResponse>>(
      `${environment.apiUrl}ai/description?cellGeoId=${geoId}&cellType=${cellType}&dataSection=${sectionKey}`
    );
  }

  public getAiSummaryWithScore(
    cells: CellAiSummaryRequestData[]
  ): Observable<JsonResponse<AiSummaryWithScore[]>> {
    return this.http.post<JsonResponse<AiSummaryWithScore[]>>(
      `${environment.apiUrl}compare-locations/ai-summary`,
      cells
    );
  }
}
